import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { SubscribedRoute } from "@/components/SubscribedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Wardrobe from "@/pages/Wardrobe";
import Pair from "@/pages/Pair";
import Lookbook from "@/pages/Lookbook";
import Stylist from "@/pages/Stylist";
import Services from "@/pages/Services";
import Profile from "@/pages/Profile";
import Subscribe from "@/pages/Subscribe";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Owner from "@/pages/Owner";
import Admin from "@/pages/Admin";

const withSub = (el) => <SubscribedRoute>{el}</SubscribedRoute>;
const withAuth = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors theme="dark" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/subscribe" element={withAuth(<Subscribe />)} />
            <Route path="/payment/success" element={withAuth(<PaymentSuccess />)} />
            <Route path="/payment/cancel" element={withAuth(<PaymentCancel />)} />
            <Route path="/wardrobe" element={withSub(<Wardrobe />)} />
            <Route path="/pair" element={withSub(<Pair />)} />
            <Route path="/lookbook" element={withSub(<Lookbook />)} />
            <Route path="/stylist" element={withSub(<Stylist />)} />
            <Route path="/services" element={withSub(<Services />)} />
            <Route path="/profile" element={withSub(<Profile />)} />
            <Route path="/owner" element={withAuth(<Owner />)} />
            <Route path="/admin" element={withAuth(<Admin />)} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
